interface LocalStorageCart {
	partNumbers: string[];
	productsCount: number;
}

const LOCAL_STORAGE_CART_KEY = 'cart';

export const getLocalStorageCart = (): LocalStorageCart => {
	if (typeof window === 'undefined') return { partNumbers: [], productsCount: 0 };
	const localStorageCart = window.localStorage.getItem(LOCAL_STORAGE_CART_KEY);
	return localStorageCart ? JSON.parse(localStorageCart) : { productsCount: 0, partNumbers: [] };
};

export const setLocalStorageCart = (partNumbers: string[]): void => {
	const localStorageCart = getLocalStorageCart();
	const newCart = {
		partNumbers: [...localStorageCart.partNumbers, ...partNumbers],
	};
	window.localStorage.setItem(LOCAL_STORAGE_CART_KEY, JSON.stringify(newCart));
};

export const removeLocalStorageCart = (): void => {
	window.localStorage.removeItem(LOCAL_STORAGE_CART_KEY);
};
